/**
 * List of authorized administrators.
 * In a production-grade system, this would eventually pull from a 
 * "roles" table in the database or an ADMIN_EMAILS env variable.
 */
export const ADMIN_EMAILS = [
  'martin@bioinfometrics.com'
];


/**
 * Client-side safe check (do not use for security, only for UI visibility)
 */
export function isUserAdmin(email: string | null | undefined): boolean {
  if (!email) return false;
  return ADMIN_EMAILS.includes(email);
}
